// @ts-nocheck
import { YStack, XStack, Text, Paragraph } from 'tamagui';
import { Container } from '../components/Container';
import { PageLayout } from '../components/PageLayout';
import { WaitlistForm } from '../components/WaitlistForm';
import { useIsMobile } from '../hooks/useIsMobile';

const contactLinks = [
  {
    label: 'Email',
    value: 'dans@romans.dev',
    onPress: () => window.open('mailto:dans@romans.dev'),
  },
  {
    label: 'GitHub',
    value: 'github.com/sid-technologies',
    onPress: () => window.open('https://github.com/sid-technologies', '_blank'),
  },
];

export default function ContactPage({ theme, toggleTheme }) {
  const isMobile = useIsMobile();

  return (
    <PageLayout theme={theme} toggleTheme={toggleTheme}>
      <Container>
        <YStack paddingVertical="$8" gap="$8" maxWidth={700}>
          {/* Header */}
          <YStack gap="$4">
            <Text fontSize="$2" color="$color6" textTransform="uppercase" letterSpacing={3} fontWeight="500">
              Contact
            </Text>
            <Text fontSize={40} fontWeight="700" color="$color12" lineHeight={48}>
              Get in touch
            </Text>
          </YStack>

          {/* Contact links */}
          <YStack gap="$3">
            {contactLinks.map((link) => (
              <XStack
                key={link.label}
                flexDirection="row"
                alignItems="baseline"
                gap="$4"
                paddingVertical="$3"
                borderBottomWidth={1}
                borderBottomColor="$color3"
              >
                <Text fontSize="$3" color="$color7" width={80} flexShrink={0}>
                  {link.label}
                </Text>
                <Text
                  fontSize="$4"
                  fontWeight="500"
                  color="$amber7"
                  cursor="pointer"
                  hoverStyle={{ opacity: 0.7 }}
                  onPress={link.onPress}
                  style={{ transition: 'opacity 0.15s' }}
                >
                  {link.value}
                </Text>
              </XStack>
            ))}
          </YStack>

          <Paragraph fontSize="$4" color="$color8" lineHeight={26}>
            For product-specific inquiries, visit the individual product pages for detailed
            information and documentation.
          </Paragraph>

          {/* Waitlist */}
          <YStack gap="$4" paddingTop="$4" borderTopWidth={1} borderTopColor="$color4">
            <YStack gap="$2">
              <Text fontSize="$6" fontWeight="600" color="$color12">
                Stay updated
              </Text>
              <Paragraph fontSize="$3" color="$color8" lineHeight={22}>
                Join the waitlist to receive product updates and launch announcements.
              </Paragraph>
            </YStack>
            <WaitlistForm product="general" source="contact-page" accent="#a03030" buttonText="Join Waitlist" />
          </YStack>
        </YStack>
      </Container>
    </PageLayout>
  );
}
